import "@mypos/ui/styles";
import React from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "@mypos/ui";
import { App } from "./App";
import { installTillShim } from "./lib/tillShim";

// Install the full Till bridge before React mounts. This makes the Till's
// Connected wrappers, adapters, and stores work in the PWA: every
// window.till.* call is shimmed to fetch() via lib/api. Hardware namespaces
// (printer, labelPrinter, power) become safe no-ops; PwaPos renders an
// on-screen receipt instead of driving thermal hardware.
installTillShim();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>,
);
